// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Sane
import { Sane } from 'sane-ui'
import * as components from './components'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import singleProduct from './routes/single_product';
import woocommerceAccount from './routes/woocommerce_account';
// import woocommerceCart from './routes/woocommerce_cart';
import woocommerceCheckout from './routes/woocommerce_checkout';
// import woocommerceEditAccount from './routes/woocommerce_edit_account';
import woocommerceShop from './routes/woocommerce_Shop';

// import 'jquery-validation'

// const imagesLoaded = require('imagesloaded');
// imagesLoaded.makeJQueryPlugin( $ );

require('lazysizes')
// require('lazysizes/plugins/parent-fit/ls.parent-fit')
// window.lazySizesConfig.init = false

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  singleProduct,
  // woocommerceCart,
  woocommerceCheckout,
  // woocommerceEditAccount,
  woocommerceAccount,
  woocommerceShop,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents()

  let delay = (window.location.hostname === 'localhost') ? 1500 : 0
  setTimeout(() => {
    Sane.initComponents(components, $('[data-component]'), true)
  }, delay)
});



// WEBPACK FOOTER //
// ./scripts/main.js